module.exports = __webpack_public_path__ + "static/media/inward.aa92752c.svg";